import Box from '@mui/material/Box';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Dialog, DialogTitle } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useMemo } from 'react';
import { transformKeyToTitle } from '../utils/transformKeyToTitle';
import { CheckDetails } from '../interfaces';
import { CopyTextCell } from './GridCells/CopyTextCell';
import { formatDate } from '../utils/formatDate';
import { CheckActionsCell } from './GridCells/CheckActionsCell';

interface Props {
    open: boolean;
    checks: CheckDetails[];
    onClose: () => void;
}

export const OscarCheckDialog = ({ checks, open, onClose }: Props) => {
    const columns: GridColDef[] = useMemo(() => {
        return [
            {
                key: 'CreatedAt',
                valueFormatter: formatDate,
            },
            {
                key: 'Url',
                renderCell: CopyTextCell,
            },
            { key: 'isFinal' },
            {
                key: 'Actions',
                renderCell: CheckActionsCell,
            },
        ].map((col) => {
            return {
                field: col.key,
                headerName: transformKeyToTitle(col.key),
                width: 140,
                renderCell: col.renderCell,
                valueFormatter: col.valueFormatter,
                align: 'left',
                headerAlign: 'left',
            };
        });
    }, []);

    const rows = useMemo(
        () =>
            (checks ?? []).map((c) => ({
                ...c,
                CreatedAt: new Date(c.CreatedAt),
            })),
        [checks],
    );

    return (
        <Dialog onClose={onClose} open={open}>
            <DialogTitle
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                Oscar Checks
                <CloseIcon sx={{ cursor: 'pointer' }} onClick={onClose} />
            </DialogTitle>
            <Box sx={{ width: '600px' }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    disableRowSelectionOnClick
                    hideFooterPagination={true}
                />
            </Box>
        </Dialog>
    );
};
